module.exports = __webpack_public_path__ + "static/media/bg_beach_escapes.09a3f1a8.jpg";